module.exports = __webpack_public_path__ + "static/media/web.edf01ac2.config";